<template>
  <b-card
    class="card-employment-policies-management"
    :title="
      $t('label_reports_managementReport_disaggregatedQuestions_title') +
      ' - ' +
      $t(title)
    "
  >
    <div class="table">
      <b-row class="header">
        <b-col cols="1">
          {{ $t("label_reports_managementReport_number_caption") }}
        </b-col>
        <b-col class="question">
          {{ $t("label_reports_managementReport_question_caption") }}
        </b-col>
        <b-col cols="3">
          {{ $t("label_reports_managementReport_answer_caption") }}
        </b-col>
      </b-row>
      <div
        v-for="(question, indexQuestion) in getEmploymentPolicies[
          employmentPoliciesSection
        ].questions"
        :key="question.number"
      >
        <b-row
          v-if="
            indexQuestion < numberOfQuestion + starterQuestion &&
            indexQuestion >= starterQuestion
          "
          class="table-row"
        >
          <b-col class="number" cols="1">
            {{ $t(question.number) }}
          </b-col>
          <b-col class="question">
            {{ $t("label_" + question.field) }}
          </b-col>
          <b-col
            v-if="question.answer == 'string'"
            class="answer"
            :class="styles[question.answer]"
            cols="3"
          >
            {{
              $t(
                "optionList_selfAssessment_employmentPolicies_responses_noAnswer"
              )
            }}
          </b-col>
          <b-col
            v-else
            class="answer"
            :class="styles[question.answer]"
            cols="3"
          >
            {{ $t(question.answer) }}
          </b-col>
        </b-row>
      </div>
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CardEmploymentPoliciesManagement",
  props: {
    employmentPoliciesSection: {
      type: String,
      default: "selfAssessment_employmentPolicies_internalCommunication",
    },
    title: {
      type: String,
      default:
        "label_reports_managementReport_internalExternalCommunication_lettlerhead_title",
    },
    numberOfQuestion: {
      type: Number,
      default: 1000,
    },
    starterQuestion: {
      type: Number,
      default: 0,
    },
  },
  data: function () {
    return {
      styles: {
        optionList_selfAssessment_employmentPolicies_responses_always: "always",
        optionList_selfAssessment_employmentPolicies_responses_sometimes:
          "sometimes",
        optionList_selfAssessment_employmentPolicies_responses_never: "never",
        string: "",
      },
    };
  },
  computed: mapGetters(["getEmploymentPolicies"]),
};
</script>
<style lang="scss" scoped>

@import "../../assets/css/variables.scss";
.card-employment-policies-management {
  .table {
    font-size: 1.1rem;
    text-align: center;
    line-height: 24px;
    .row {
      margin: 5px 0;
    }
    .question {
      text-align: left;
    }
    .header {
      font-size: 1rem;
      font-family: $font-subtitle;
    }
    .table-row {
      border: 1px solid #000;
      min-height: 60px;
      align-items: center;
    }
    .number {
      font-family: $font-subtitle;
      font-size: 1.3rem;
    }
    .answer {
      background-color: gray;
      min-height: inherit;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 1.3rem;
      font-family: $font-subtitle;
      border: 2px solid #000;
      border-left: 3px solid #000;
    }
    .always {
      background-color: $positive-color;
    }
    .sometimes {
      background-color: $intermediate-color;
    }
    .never {
      background-color: $negative-color;
    }
  }
}
</style>
